// extracted by mini-css-extract-plugin
module.exports = {"content":"DoorState_content__c5wfU","door":"DoorState_door__DWyMO","indicator":"DoorState_indicator__gB6yg","status":"DoorState_status__WEk9B"};